export const vulnerabilityKeys = {
  all: ["vulnerability"] as const,
  object: (projectId: string, variantId: string, objectId: string) =>
    [...vulnerabilityKeys.all, projectId, variantId, objectId] as const,
};
